import request from '@/utils/request';

export function getStudentInfo() {
    return request({
        url: `/system/student/getSchoolStudentInfo`,
        method: 'get',
    })
}

export function updateStudentInfo(data) {
    return request({
        url: `/system/student/update`,
        method: 'post',
        data
    })
}


export function updatePassWord(data) {
    return request({
        url: `/system/student/updatePassWord`,
        method: 'post',
        data
    })
}

export function addStudentAddress(data) {
    return request({
        url: `/system/student/addStudentAddress`,
        method: 'post',
        data
    })
}